import { createFileRoute } from '@tanstack/react-router'
import { TabularReportScreen } from '@/components/tabular-report/tabular-report-screen'

/**
 * Route shell for the outstanding cheques report (WP09): every cheque that
 * is still paper. A child of `cheques.tsx`, whose guard already ran.
 */
export const Route = createFileRoute('/_authenticated/accounting/cheques/outstanding')({
  component: OutstandingChequesRoute,
})

function OutstandingChequesRoute() {
  return (
    <TabularReportScreen
      path="/accounting/cheques/outstanding"
      trail={[{ label: 'accounting:cheques.title', href: '/accounting/cheques' }]}
      search={{}}
      onSearchChange={() => undefined}
      period="none"
      exportPermission="accounting_report.export"
    />
  )
}
